(function () {
  'use strict';

  angular.module('ringbaPortal')
    .filter('currencyAmountFilter', function(){
      return function(amountObject){
        const currencyMap = {
          USD: '$'
        };
        return currencyMap[amountObject.currencyType.code] + amountObject.amount;
      };
    });
})();
